module.exports = __webpack_public_path__ + "static/media/2pagae_02.2e22e0ee.jpg";